
const getCharLength = () => {
   if(window.innerWidth >= 1024) return 80
   if(window.innerWidth >= 768) return 70
   if(window.innerWidth >= 640) return 80
   if(window.innerWidth < 640) return 110 
}

export default getCharLength;